import * as React from "react";
import { Field } from "formik";
import { Select } from "components/common";
import ControlLabel from "components/bootstrap/ControlLabel";
import Input from "components/bootstrap/Input";
import { DEFAULT_ORIENTATION } from "report/Constants";
const ORIENTATION_OPTIONS = [
  { label: "Portrait", value: "portrait" },
  { label: "Landscape", value: "landscape" }
];
const PageSizeSelect = ({ disabled }) => /* @__PURE__ */ React.createElement(Field, { name: "layout.orientation" }, ({ field: { name, value, onChange }, meta: { error } }) => /* @__PURE__ */ React.createElement(Input, { id: name, error }, /* @__PURE__ */ React.createElement(ControlLabel, null, "Orientation"), /* @__PURE__ */ React.createElement(
  Select,
  {
    disabled,
    onChange: (newValue) => onChange({ target: { name, value: newValue } }),
    value: value != null ? value : DEFAULT_ORIENTATION,
    inputId: name,
    placeholder: "Pick an orientation",
    clearable: false,
    options: ORIENTATION_OPTIONS
  }
)));
export default PageSizeSelect;
